export default __webpack_public_path__ + "static/media/the_surfer.3dd67e43.jpg";